import { Job, JobAbstract, UserAbstract } from '@sciper/api-client'

export const DEFAULT_PAGE_SIZE = 20

export type JobFilterOptions = {
  searchKey?: string
  keywordList?: string[]
  departmentIdList?: string[]
}

export type JobPageOptions = {
  page: number
  size: number
}

export type JobsResult = {
  jobs: Job[]
  filterOptions: JobFilterOptions
}

export type JobAbstractsResult = {
  jobAbstracts: JobAbstract[]
  filterOptions: JobFilterOptions
}

export type JobByUniversityResult = {
  jobAbstracts: JobAbstract[]
  universityId: string
}

export type InterestedUsersResult = {
  users: UserAbstract[]
  jobId: string
}

export type TimeGroupedJobAbstracts = {
  date: Date
  jobAbstracts: JobAbstract[]
}
